<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>

    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div style="margin-top:22px">
        <el-form :model="cuponForm" :rules="cuponRules" ref="cuponForm" label-width="130px" class="info-form">
          <el-form-item label="优惠券名称" prop="name">
            <el-input style="width:442px" v-model="cuponForm.name" placeholder="请输入优惠券名称" maxlength="14" show-word-limit
              clearable></el-input>
          </el-form-item>
          <el-form-item label="优惠券面值" prop="value">
            <el-input style="width:442px" type="number" v-model="cuponForm.value" placeholder="请输入优惠券面值"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="最低满足金额" prop="limitValue">
            <el-input style="width:442px" type="number" v-model="cuponForm.limitValue" placeholder="请输入优惠券使用最低满足金额"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="起止时间" prop="startEndTime">
            <el-date-picker v-model="cuponForm.startEndTime" type="datetimerange" range-separator="至" style="width:442px"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效时间" prop="validDays">
            <el-input style="width:442px" oninput="value=value.replace(/[^0-9]/g,'')" type="number"
              v-model="cuponForm.validDays" placeholder="请输入有效时间（天）" clearable></el-input>
          </el-form-item>
          <el-form-item label="优惠券发放数量" prop="quantity">
            <el-input style="width:442px" type="number" v-model="cuponForm.quantity" placeholder="请输入优惠券发放数量"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="每人限领数量" prop="personelQuantity">
            <el-input style="width:442px" type="number" v-model="cuponForm.personelQuantity" placeholder="请设置每人限领数量"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="showFlag">
            <el-radio v-model="cuponForm.showFlag" label="1">是</el-radio>
            <el-radio v-model="cuponForm.showFlag" label="2">否</el-radio>
          </el-form-item>
          <el-form-item label="适用范围" prop="scope">
            <el-radio v-model="cuponForm.scope" v-for="(item, index) in dictionaries.coupon_scope" :label="item.dictId"
              :key="index" @change="getLimitChange">{{ item.dictName }}</el-radio>
          </el-form-item>
          <el-form-item label="" prop="user" v-if="cuponForm.scope">
            <div v-if="cuponForm.scope == '2' || cuponForm.scope == '3'">
              <span style="margin-right:10px;">{{ cuponForm.scope == '2' ? "类目" : "标签" }}</span>
              <el-button type="primary" size="mini">{{ cuponForm.scope == '2' ? "选择类目" : "选择标签"
              }}</el-button>
              <el-input v-if="cuponForm.scope == '3'" v-model="tagName" placeholder="标签名称"
                style="width:200px;margin: 0 10px;"></el-input>
              <div v-if="cuponForm.scope == '3'" class="primary-mini" style="line-height:32px;" @click="getTagList()">查询
              </div>
            </div>
            <div class="cascabox" v-if="cuponForm.scope == '2'">
              <el-cascader-panel :key="cKey" ref="cat" v-model="selectedCategory" :options="categoryList"
                :props="{ multiple: true, checkStrictly: true, emitPath: false, }" @change="getCategoryChange">
              </el-cascader-panel>
              <!-- <el-cascader-panel :key="cKey" ref="cat" v-model="selectedCategory" :options="categoryList"
                  :props="{ multiple: true, checkStrictly: true, emitPath: false }" @change="getCategoryChange">
                </el-cascader-panel> -->
              <!-- <div class="cascabtnbox">
                              <el-button type="primary" plain size="mini">确定</el-button>
                              <el-button type="primary" plain size="mini">返回</el-button>
                          </div> -->
            </div>
            <div class="cascabox table-incl" v-if="cuponForm.scope == '3'">
              <div class="table-top">
                <div class="table-top-left" style="margin-bottom:10px;">
                  <div class="primary-plain" @click="batchSelectTag(1)">批量选择</div>
                  <div class="primary-plain" @click="batchSelectTag(2)">批量取消</div>
                  <!-- <el-button type="primary" plain size="mini"
                                      @click="batchSelectTag(1)">批量选择</el-button>
                                  <el-button type="primary" plain size="mini"
                                      @click="batchSelectTag(2)">批量取消</el-button> -->
                </div>
              </div>
              <div class="goods-table">
                <el-table :data="tagList" ref="tagTable" style="width:100%"
                  :header-cell-style="{ 'background': '#F8F8F8', 'color': '#333333' }"
                  @selection-change="handleSelectionChange">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column label="标签" prop="name"></el-table-column>
                  <el-table-column label="排序" prop="sort">
                  </el-table-column>
                  <el-table-column label="是否对外展示" prop="">
                    <template slot-scope="scope">
                      <p>{{ scope.row.isShow == 1 ? '是' : '否' }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" prop="tagName">
                    <template slot-scope="scope">
                      <div class="tag-status">
                        <div class="circle" :style="{ 'background-color': scope.row.status == 1 ? '#67c23a' : 'red' }">
                        </div>
                        <span>{{ scope.row.status == 1 ? '启用' : '停用' }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="">
                    <template slot-scope="scope">
                      <el-button type="text" v-if="!scope.row.selected" @click="handleSelectTag(scope)">选择</el-button>
                      <el-button type="text" style="color:red;" v-if="scope.row.selected"
                        @click="handleSelectTag(scope)">取消</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="overflow:hidden;background:#F5F5F5;">
                <div style="float: right;margin-top: 10px;">
                  <el-pagination background @size-change="onSizeChange" @current-change="onCurrentChange"
                    :current-page="labelPageNo" :page-sizes="[5, 10, 20]" :page-size="labelPageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
                  </el-pagination>
                </div>
              </div>
            </div>
            <div class="cascabox" v-if="cuponForm.scope == '4'">
              <div class="table-top" style="margin-bottom:20px;">
                <div class="table-top-left">
                  <div style="display:flex" v-if="showSelectedGoods">
                    <el-button :type="gType == '1' ? 'primary' : ''" size="small" @click="selectG('1')">普通商品</el-button>
                    <el-button :type="gType == '2' ? 'primary' : ''" size="small" @click="selectG('2')">礼包商品</el-button>
                  </div>
                  <span style="margin-left:10px">商品名称</span>
                  <el-input v-model="goodsName" placeholder="商品名称" style="width:200px;margin: 0 10px;"></el-input>
                  <!-- <el-button type="primary" plain size="mini" @click="checkGoodsList">查询</el-button> -->
                  <div class="primary-mini" style="line-height:32px;" @click="checkGoodsList">查询</div>
                </div>
                <div class="table-top-left">
                  <div class="primary-plain" @click="batchSelectGoods(1)">批量选择</div>
                  <div class="primary-plain" @click="batchSelectGoods(2)">批量取消</div>
                  <div class="primary-plain" v-if="showSelectedGoods" @click="handleShowSelect">已选择商品</div>
                  <div class="primary-plain" v-else @click="handleShowSelect">选择商品</div>
                  <!-- <el-button type="primary" plain size="mini" @click="batchSelectGoods(1)"
                                      v-if="showSelectedGoods">批量选择</el-button>
                                  <el-button type="primary" plain size="mini"
                                      @click="batchSelectGoods(2)">批量取消</el-button>
                                  <el-button type="primary" plain size="mini" v-if="showSelectedGoods"
                                      @click="handleShowSelect">已选择商品</el-button>
                                  <el-button type="primary" plain size="mini" v-else
                                      @click="handleShowSelect">选择商品</el-button> -->
                </div>
              </div>
              <div class="goods-table" style="border:1px solid #EBEEF5;" v-if="gType == 1">
                <el-table :data="goodsList" ref="goodsTable" style="width:100%"
                  :header-cell-style="{ 'background': '#F8F8F8', 'color': '#333333' }"
                  @selection-change="handleGoodsSelectionChange">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column label="商品ID" prop="id"></el-table-column>
                  <el-table-column label="商品名称" prop="name" width="250">
                    <template slot-scope="scope">
                      <p>{{ scope.row.name }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品图片" prop="image">
                    <template slot-scope="scope">
                      <el-image class="table-image" :src="scope.row.image"></el-image>

                    </template>
                  </el-table-column>
                  <el-table-column label="商品类型" prop="typeLabel">
                    <template slot-scope="scope">
                      <p>普通商品</p>

                    </template>
                  </el-table-column>
                  <el-table-column label="商品状态" prop="status">
                    <template slot-scope="scope">
                      <p :style="{ color: scope.row.status === 1 ? '#67c23a' : 'red' }">
                        {{ scope.row.statusLabel }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="">
                    <template slot-scope="scope">
                      <el-button type="text" v-if="!scope.row.selected" @click="handleSelectGoods(scope)">选择</el-button>
                      <el-button type="text" style="color:red;" v-if="scope.row.selected"
                        @click="handleSelectGoods(scope)">取消</el-button>

                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="overflow:hidden;background:#F5F5F5;" v-if="gType == 1">
                <div style="float: right;margin-top: 10px;">
                  <el-pagination background @size-change="onGoodsSizeChange" @current-change="onGoodsCurrentChange"
                    :current-page="goodsPageNo" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
                  </el-pagination>
                </div>
              </div>
              <div class="goods-table" style="border:1px solid #EBEEF5;" v-if="gType == 2">
                <el-table :data="goodsList1" ref="goodsTable" style="width:100%"
                  :header-cell-style="{ 'background': '#F8F8F8', 'color': '#333333' }"
                  @selection-change="handleGoodsSelectionChange1">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column label="商品ID" prop="id"></el-table-column>
                  <el-table-column label="商品名称" prop="name" width="250">
                    <template slot-scope="scope">
                      <p>{{ scope.row.name }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品图片" prop="image">
                    <template slot-scope="scope">
                      <el-image class="table-image" :src="scope.row.images"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品类型" prop="typeLabel">
                    <template slot-scope="scope">
                      <p>礼包商品</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品状态" prop="status">
                    <template slot-scope="scope">
                      <p :style="{ color: scope.row.status === 1 ? '#67c23a' : 'red' }">
                        {{ scope.row.statusLabel }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="">
                    <template slot-scope="scope">
                      <el-button type="text" v-if="!scope.row.selected" @click="handleSelectGoods1(scope)">选择</el-button>
                      <el-button type="text" style="color:red;" v-if="scope.row.selected"
                        @click="handleSelectGoods1(scope)">取消</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="overflow:hidden;background:#F5F5F5;" v-if="gType == 2">
                <div style="float: right;margin-top: 10px;">
                  <el-pagination background @size-change="onGoodsSizeChange1" @current-change="onGoodsCurrentChange1"
                    :current-page="goodsPageNo1" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize1"
                    layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum1">
                  </el-pagination>
                </div>
              </div>
              <div class="goods-table" style="border:1px solid #EBEEF5;" v-if="gType == 3">
                <el-table :data="goodsList3" ref="goodsTable" style="width:100%"
                  :header-cell-style="{ 'background': '#F8F8F8', 'color': '#333333' }"
                  @selection-change="handleGoodsSelectionChange3">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column label="商品ID" prop="id"></el-table-column>
                  <el-table-column label="商品名称" prop="name" width="250">
                    <template slot-scope="scope">
                      <p>{{ scope.row.name }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品图片" prop="image">
                    <template slot-scope="scope">
                      <el-image class="table-image" :src="scope.row.imageUrl"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品类型" prop="typeLabel">
                    <template slot-scope="scope">
                      <p>{{ scope.row.typeFlagLabel }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品状态" prop="status">
                    <template slot-scope="scope">
                      <p :style="{ color: scope.row.status === 1 ? '#67c23a' : 'red' }">
                        {{ scope.row.statusLabel }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" prop="">
                    <template slot-scope="scope">
                      <el-button type="text" v-if="!scope.row.selected" @click="handleSelectGoods3(scope)">选择</el-button>
                      <el-button type="text" style="color:red;" v-if="scope.row.selected"
                        @click="handleSelectGoods3(scope)">取消</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="overflow:hidden;background:#F5F5F5;" v-if="gType == 3">
                <div style="float: right;margin-top: 10px;">
                  <el-pagination background @size-change="onGoodsSizeChange3" @current-change="onGoodsCurrentChange3"
                    :current-page="goodsPageNo3" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize3"
                    layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum3">
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="display:inline-block;">
            <div class="selected" v-if="cuponForm.scope == '2' && selectedCName.length > 0">
              <span>已选</span>
              <div class="selectedbox">
                <div class="selected-item" v-for="(item, index) in selectedCName">
                  {{ item }}
                  <div class="labeliconbox">
                    <i class="el-icon-circle-close labelicon" @click="deleteSelectedCName(index)"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="selected" v-if="cuponForm.scope == '3' && seletedTag.length > 0">
              <span style="line-height:28px;">已选</span>
              <div class="selectedbox">
                <div class="selected-item" v-for="(item, index) in seletedTag">
                  {{ item.name }}
                  <div class="labeliconbox">
                    <i class="el-icon-circle-close labelicon" @click="deleteTag(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="优惠券绑定上级" prop="bindUserId">
            <div>
              <el-input placeholder="请选择上级" v-model="bindName" style="width: 30%" @focus="selectUser" readonly></el-input>
            </div>
          </el-form-item>
          <el-form-item label="适用用户" prop="userScope" class="brand-id">
            <el-select v-model="cuponForm.userScope" placeholder="请选择适用用户" filterable clearable style="width:442px">
              <el-option v-for="item in dictionaries.coupon_user_scope" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用类型" prop="useType">
            <el-radio v-model="cuponForm.useType" label="1">可分享</el-radio>
            <el-radio v-model="cuponForm.useType" label="0">仅自用</el-radio>
          </el-form-item>
          <el-form-item label="优惠券类型" prop="typeFlag" class="brand-id">
            <el-select v-model="cuponForm.typeFlag" placeholder="请选择优惠券类型" filterable clearable style="width:442px">
              <el-option v-for="item in dictionaries.coupon_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属券包" prop="typeFlag" class="couponPackageId">
            <el-select v-model="cuponForm.couponPackageId" placeholder="请选择所属券包" filterable clearable style="width:442px">
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券跳转地址" prop="redirectUrlType">
            <el-radio v-model="cuponForm.redirectUrlType" label="1">券包活动页</el-radio>
            <el-radio v-model="cuponForm.redirectUrlType" label="0">商品分类页<span
                style="color: #C0C0CC;margin-left: 4px;">（若优惠券关联多个商品）</span>/商品详情页<span
                style="color: #C0C0CC;margin-left: 4px;">（若优惠券只关联单个商品）</span></el-radio>
          </el-form-item>
          <el-form-item label="跨商品满减" prop="crossGoods">
            <el-radio v-model="cuponForm.crossGoods" label="1">是</el-radio>
            <el-radio v-model="cuponForm.crossGoods" label="0">否</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <div class="content bottom-but">
        <el-button type="warning" @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" @click="submitFn">提交</el-button>
      </div>
      <div style="height:10px"></div>
    </div>
    <el-dialog title="选择用户" :visible.sync="dialogUser" append-to-body width="40%">
      <div style="display: flex;">
        <div style="margin-left: 10px;margin-top: 10px;">用户列表</div>
        <div class="dialog-search" style="display: flex;margin-left: 10px;">
          <div>
            <el-input placeholder="请输入用户信息" clearable v-model="keywords" style="width: 300px;"></el-input>
          </div>
          <div style="margin-left: 20px;">
            <el-button type="primary" @click="getfindVipCustomerPage">查询</el-button>
          </div>
        </div>
      </div>

      <div>
        <el-table border :data="tableData" tooltip-effect="dark" style="width: 100%; margin-top: 20px; margin-left: 10px"
          @row-click="rowClick">
          <el-table-column prop="select" width="55">
            <template slot-scope="scope">
              <el-radio v-model="radioIdSelect" :label="scope.row.id">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="ID" prop="id"> </el-table-column>
          <el-table-column label="昵称" prop="nickName">
          </el-table-column>
          <el-table-column prop="phone" label="电话" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div style="float: right; margin-top: 10px">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
            :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
        </div>
        <div style="margin-top: 60px; text-align: center">
          <!-- <el-button @click="dialogUser = false">取消</el-button>
          <el-button style="margin-right: 30px" type="primary" @click="submit">确认</el-button> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
  components: { breadcrumbTop, breadcrumbSearch },
  data() {
    return {
      tagName: '',
      bindName: '',
      tableData: [],
      dialogUser: false,
      keywords: '',
      radioIdSelect: '',
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
      gType: '1',
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '优惠券管理', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '查看优惠券', path: '', type: '0' }
        ]
      },
      cuponForm: {
        name: '',//优惠券名称
        value: '',//优惠券面值
        limitValue: '',//最低满足金额
        startTime: '',//开始时间
        endTime: '',//结束时间
        validDays: '',//有效时间
        quantity: '',//优惠券发放数量
        personelQuantity: '',//每人限领数量
        showFlag: '',//是否显示
        scope: '',//适用范围
        userScope: '',//适用用户（字典：coupon_user_scope）
        typeFlag: '',//优惠券类型（字典：coupon_type）
        startEndTime: '',
        bindUserId: '',
        useType: '',
        redirectUrlType: '',
        couponPackageId: '',
        crossGoods: ''
      },
      cuponRules: {
        name: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { min: 1, max: 14, message: '长度在 1 到 14 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入优惠券面值', trigger: 'blur' }
        ],
        limitValue: [
          { required: true, message: '请输入优惠券最低满足金额', trigger: 'blur' }
        ],
        startEndTime: [
          { required: true, message: '请选择优惠券起止时间', trigger: 'blur' }
        ],
        validDays: [
          { required: true, message: '请输入优惠券有效时间', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入优惠券发放数量', trigger: 'blur' }
        ],
        personelQuantity: [
          { required: true, message: '请输入优惠券每人限领数量', trigger: 'blur' }
        ],
        showFlag: [
          { required: true, message: '请选择是否显示', trigger: 'blur' }
        ],
        scope: [
          { required: true, message: '请选择适用范围', trigger: 'blur' }
        ],
        userScope: [
          { required: true, message: '请选择适用用户', trigger: 'blur' }
        ],
        useType: [
          { required: true, message: '请选择使用类型', trigger: 'blur' }
        ],
        typeFlag: [
          { required: true, message: '请选择优惠券类型', trigger: 'blur' }
        ],
        couponPackageId: [
          { required: true, message: '请选择所属券包', trigger: 'blur' }
        ],
        redirectUrlType: [
          { required: true, message: '请选择优惠券跳转地址', trigger: 'blur' }
        ],
      },
      platform: [],
      categoryList: [],
      goodsList: [],//商品数据
      goodsPageNo: 1,//商品表格页数
      goodsPageSize: 5,//商品表格每页显示条数
      goodsTotalNum: 0,//商品表格总条数
      goodsList1: [],//礼包商品数据
      goodsPageNo1: 1,//商品表格页数
      goodsPageSize1: 5,//商品表格每页显示条数
      goodsTotalNum1: 0,//商品表格总条数
      goodsList3: [],//商品数据
      goodsPageNo3: 1,//商品表格页数
      goodsPageSize3: 5,//商品表格每页显示条数
      goodsTotalNum3: 0,//商品表格总条数
      tagList: [],//标签数据
      labelPageNo: 1,//标签页数
      labelPageSize: 5,//标签表格每页显示条数
      labelTotalNum: 0,//标签总数
      ids: [],
      selectedCategory: [],
      selectedCName: [],
      cKey: 1,
      seletedTag: [],//已选标签列表
      tagSelectionList: [],
      seletedGoods: [],//已选商品列表
      seletedGoods1: [],//已选商品列表
      seletedGoods3: [],//已选商品列表
      goodsName: '',
      goodsSelectionList: [],
      goodsSelectionList1: [],
      goodsSelectionList3: [],
      showSelectedGoods: true,
      breadcrumbTitle: '新增优惠券',
      dictionaries: {
        coupon_scope:
          [
            { groupId: "coupon_scope", groupName: "优惠券使用范围", dictId: "1", dictName: "全品类", remark: null },
            { groupId: "coupon_scope", groupName: "优惠券使用范围", dictId: "2", dictName: "选择类目", remark: null },
            { groupId: "coupon_scope", groupName: "优惠券使用范围", dictId: "3", dictName: "选择标签", remark: null },
            { groupId: "coupon_scope", groupName: "优惠券使用范围", dictId: "4", dictName: "选择商品", remark: null },],
        coupon_user_scope: [],
        coupon_type: []
      },
      userList: []
    }
  },
  created() {
    if (this.$route.query.type == 'add') {
      this.searchList.list[0].title = '新增优惠券'
    } else {
      this.searchList.list[0].title = '查看/编辑优惠券'
    }
    let cid = this.$route.query.id || null;
    this.cid = cid;
    if (cid) {
      this.breadcrumbTitle = '编辑优惠券'
      this.getCoupon()
    }
    this.getCategoryList()//获取类目列表数据
    this.getGoodsList()//获取商品数据
    this.getTagList()//获取标签表格数据
    this.getDictionaries('coupon_user_scope')
    this.getDictionaries('coupon_type')
    this.getUList()
  },
  methods: {
    getUList() {
      let data = {
        pageNo: 1,
        pageSize: 999999999,
      }
      this.axios.get('/couponPackage/couponPackageList')
        .then(res => {
          console.log(res)
          let arr = []
          if (res.code == 0) {
            // let obj = {
            //   id: '',
            //   name: '通用券包（全场通用）'
            // }
            // arr.push(obj)
            this.userList = arr.concat(res.data)
          }
        })
    },
    rowClick(row) {
      this.cuponForm.bindUserId = row.id
      this.radioIdSelect = row.id
      this.bindName = row.nickName
      this.dialogUser = false
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getUserList()
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getUserList()
    },
    selectUser() {
      this.dialogUser = true
      this.getUserList()
    },
    getfindVipCustomerPage() {
      this.pageNo = 1
      this.getUserList()
    },
    getUserList() {
      this.axios.post('/user/pageList', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nickName: this.keywords
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {

            this.tableData = res.data.list;
            this.totalNum = res.data.totalNum;
          }
        })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.axios.get('/getDictGroup?groupId=' + type).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    selectG(val) {
      this.gType = val
      this.getGoodsList()//获取商品数据
    },
    getCoupon() {
      this.axios.get('/coupon/get?id=' + this.cid)
        .then(res => {
          console.log(res)

          if (res.code == 0) {
            let data = res.data;
            data.showFlag = data.showFlag + '';
            data.scope = data.scope + '';
            data.userScope = data.userScope + '';
            data.typeFlag = data.typeFlag + '';
            data.crossGoods = data.crossGoods + ''
            data.redirectUrlType = data.redirectUrlType + ''
            Object.assign(this.cuponForm, data)
            let startEndTime = [];
            startEndTime[0] = data.startTime;
            startEndTime[1] = data.endTime
            this.cuponForm.startEndTime = startEndTime;
            this.cuponForm.useType = String(data.useType)
            console.log(this.cuponForm)
            if (this.cuponForm.scope == '2' && this.selectedCategory.length == 0) {
              this.selectedCategory = data.scopeIds.map(item => {
                return item.id + ''
              })
              console.log(this.selectedCategory)
            }
            if (this.cuponForm.scope == '3' && this.seletedTag.length == 0) {
              this.seletedTag = data.scopeIds.map(item => {
                return {
                  id: item.id,
                  name: item.name
                }
              })
            }
            if (this.cuponForm.scope == '4') {
              this.seletedGoods3 = data.scopeIds.map(item => {
                return {
                  id: item.id,
                  typeFlag: item.typeFlag
                }
              })
            }
          }
          setTimeout(() => {
            if (this.$refs['cat']) {
              this.selectedCName = this.$refs['cat'].getCheckedNodes().map(item => {
                let label = '';
                for (let i = 0; i < item.pathLabels.length; i++) {
                  let j = i < (item.pathLabels.length - 1) ? '>' : ''
                  label += item.pathLabels[i] + j
                }
                return label
              })
            }

          }, 1000)
          this.bindName = res.data.bindUserName
          this.cuponForm.bindUserId = res.data.bindUserId
          this.radioIdSelect = res.data.bindUserId
          this.$forceUpdate()
        })
    },
    submitFn() {
      if (this.cuponForm.name == '') {
        this.$message.warning('请输入优惠券名称')
        return
      }
      if (this.cuponForm.value == '') {
        this.$message.warning('请输入优惠券面值')
        return
      }
      console.log(this.cuponForm.limitValue)
      if (this.cuponForm.limitValue === '') {
        console.log(6666)
        this.$message.warning('请输入优惠券最低满足金额')
        return
      }
      if (this.cuponForm.validDays == '') {
        this.$message.warning('请输入优惠券有效时间')
        return
      }
      if (this.cuponForm.quantity == '') {
        this.$message.warning('请输入优惠券发放数量')
        return
      }
      if (this.cuponForm.personelQuantity == '') {
        this.$message.warning('请输入优惠券每人限领数量')
        return
      }
      if (this.cuponForm.showFlag == '' || this.cuponForm.showFlag == null) {
        this.$message.warning('请选择是否显示')
        return
      }
      if (this.cuponForm.scope == '') {
        this.$message.warning('请选择优惠券适用范围')
        return
      }
      if (this.cuponForm.userScope == '') {
        this.$message.warning('请选择优惠券适用用户')
        return
      }
      if (!this.cuponForm.useType) {
        this.$message.warning('请选择使用类型')
        return
      }
      if (this.cuponForm.typeFlag == '') {
        this.$message.warning('请选择优惠券类型')
        return
      }

      if (this.cuponForm.startEndTime == '' || this.cuponForm.startEndTime == null) {
        this.$message.warning('请选择优惠券起止时间')
        return
      }
      if (this.cuponForm.scope == '2' && this.selectedCategory.length == 0) {
        this.$message.warning('请选择类目')
        return
      }
      if (this.cuponForm.scope == '3' && this.seletedTag.length == 0) {
        this.$message.warning('请选择标签')
        return
      }
      let seletedGoods = this.seletedGoods.concat(this.seletedGoods1).concat(this.seletedGoods3)
      if (this.cuponForm.scope == '4' && seletedGoods.length == 0) {
        this.$message.warning('请选择商品')
        return
      }
      this.cuponForm.startTime = this.cuponForm.startEndTime[0];
      this.cuponForm.endTime = this.cuponForm.startEndTime[1];
      if (this.cuponForm.scope == '1') {//全品类
        this.cuponForm.scopeIds = []
      } else if (this.cuponForm.scope == '2') {//选择类目
        this.cuponForm.scopeIds = this.selectedCategory.map(item => {
          return {
            id: item,
            typeFlag: 2
          }
        })
      } else if (this.cuponForm.scope == '3') {//选择标签
        this.cuponForm.scopeIds = this.seletedTag.map(item => {
          return {
            id: item.id,
            typeFlag: 1
          }
        })
      } else {//选择标签
        // if()
        console.log(this.seletedGoods, this.seletedGoods1)
        let seletedGoods = this.seletedGoods.concat(this.seletedGoods1).concat(this.seletedGoods3)
        this.cuponForm.scopeIds = seletedGoods.map(item => {
          return {
            id: item.id,
            typeFlag: item.typeFlag
          }
        })
      }

      let cuponForm = JSON.parse(JSON.stringify(this.cuponForm))
      delete cuponForm.startEndTime
      console.log(this.cuponForm)

      this.axios.post('/coupon/addEdit', cuponForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$router.push('./couponManage')
          }
        })

    },
    onSizeChange(e) {
      this.labelPageSize = e;
      this.getTagList()
    },
    onCurrentChange(e) {
      this.labelPageNo = e;
      this.getTagList()
    },

    onGoodsSizeChange(e) {
      this.goodsPageSize = e;
      this.getGoodsList()
    },
    onGoodsCurrentChange(e) {
      this.goodsPageNo = e;
      this.getGoodsList()
    },
    onGoodsSizeChange1(e) {
      this.goodsPageSize1 = e;
      this.getGoodsList()
    },
    onGoodsCurrentChange1(e) {
      this.goodsPageNo1 = e;
      this.getGoodsList()
    },
    onGoodsSizeChange3(e) {
      this.goodsPageSize3 = e;
      this.getSelectGoodsData()
    },
    onGoodsCurrentChange3(e) {
      this.goodsPageNo3 = e;
      this.getSelectGoodsData()
    },
    //选择商品
    handleSelectGoods(scope) {
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          typeFlag: 3
        }
        this.goodsList[scope.$index].selected = true;
        this.seletedGoods.push(data)
      } else {
        this.goodsList[scope.$index].selected = false;

        let idx = this.seletedGoods.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedGoods.splice(idx, 1)
      }
      console.log(this.seletedGoods)

      this.$forceUpdate()
    },
    //选择商品
    handleSelectGoods1(scope) {
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          typeFlag: 4
        }
        this.goodsList1[scope.$index].selected = true;
        this.seletedGoods1.push(data)
      } else {
        this.goodsList1[scope.$index].selected = false;

        let idx = this.seletedGoods1.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedGoods1.splice(idx, 1)
      }
      console.log(this.seletedGoods1)

      this.$forceUpdate()
    },
    //选择商品
    handleSelectGoods3(scope) {
      this.goodsList3[scope.$index].selected = !this.goodsList3[scope.$index].selected

      let idx3 = this.seletedGoods3.findIndex(item => {
        return item.id == scope.row.id
      })
      this.seletedGoods3.splice(idx3, 1)
      let idx1 = this.seletedGoods1.findIndex(item => {
        return item.id == scope.row.id
      })
      this.seletedGoods1.splice(idx1, 1)
      let idx = this.seletedGoods.findIndex(item => {
        return item.id == scope.row.id
      })
      this.seletedGoods.splice(idx, 1)
      this.goodsList3.splice(scope.$index, 1)
      this.$forceUpdate()
    },
    //批量选择、取消商品
    batchSelectGoods(type) {
      if (this.gType == 1) {
        if (this.goodsSelectionList.length == 0) {
          this.$message({
            message: '请选择商品',
            type: 'warning',
            // offset: 200
          });
          return
        }
        this.goodsSelectionList.forEach(item => {
          if (type == 1) {
            item.selected = true;
          } else {
            item.selected = false;
          }

        })
        // console.log(this.goodsSelectionList)
        let arr = this.goodsList.filter(item => item.selected).map(i => {
          if (i.selected) {
            return {
              id: i.id,
              typeFlag: 3
            }
          }
        })//arrDistinctByProp

        if (type == 2) {
          this.seletedGoods = this.seletedGoods.filter(item => !this.goodsSelectionList.some(item2 => item2.id == item.id))
        } else {
          this.seletedGoods = this.arrDistinctByProp(this.seletedGoods.concat(arr), 'id');
        }
        this.goodsSelectionList = [];
        this.$refs['goodsTable'].clearSelection()
        console.log(this.seletedGoods)
      } else if (this.gType == 2) {
        if (this.goodsSelectionList1.length == 0) {
          this.$message({
            message: '请选择商品',
            type: 'warning',
            // offset: 200
          });
          return
        }
        this.goodsSelectionList1.forEach(item => {
          if (type == 1) {
            item.selected = true;
          } else {
            item.selected = false;
          }

        })
        // console.log(this.goodsSelectionList1)
        let arr = this.goodsList1.filter(item => item.selected).map(i => {
          if (i.selected) {
            return {
              id: i.id,
              typeFlag: 4
            }
          }
        })//arrDistinctByProp

        if (type == 2) {
          this.seletedGoods1 = this.seletedGoods1.filter(item => !this.goodsSelectionList1.some(item2 => item2.id == item.id))
        } else {
          this.seletedGoods1 = this.arrDistinctByProp(this.seletedGoods1.concat(arr), 'id');
        }
        this.goodsSelectionList1 = [];
        this.$refs['goodsTable'].clearSelection()
        console.log(this.seletedGoods1)
      } else {
        if (this.goodsSelectionList3.length == 0) {
          this.$message({
            message: '请选择商品',
            type: 'warning',
            // offset: 200
          });
          return
        }
        this.goodsSelectionList3.forEach(item => {
          if (type == 1) {
            item.selected = true;
          } else {
            item.selected = false;
          }

        })
        // console.log(this.goodsSelectionList)
        let arr = this.goodsList3.filter(item => item.selected).map(i => {
          if (i.selected) {
            return {
              id: i.id,
              typeFlag: 3
            }
          }
        })//arrDistinctByProp

        if (type == 2) {
          this.seletedGoods3 = this.seletedGoods3.filter(item => !this.goodsSelectionList3.some(item2 => item2.id == item.id))
        } else {
          this.seletedGoods3 = this.arrDistinctByProp(this.seletedGoods3.concat(arr), 'id');
        }
        this.goodsSelectionList3 = [];
        this.$refs['goodsTable'].clearSelection()
        console.log(this.seletedGoods3)
      }

    },
    deleteTag(idx) {
      this.tagList.forEach(item => {
        if (this.seletedTag[idx].id == item.id) {
          item.selected = false;
        }
      })
      this.seletedTag.splice(idx, 1)

    },
    //选择标签
    handleSelectTag(scope) {
      //scope.row.selected==true则是已选择，执行取消操作
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          name: scope.row.name
        };
        this.tagList[scope.$index].selected = true;
        this.seletedTag.push(data)
      } else {
        this.tagList[scope.$index].selected = false;

        let idx = this.seletedTag.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedTag.splice(idx, 1)
      }
      console.log(this.seletedTag)

      this.$forceUpdate()
    },
    //批量选择、批量取消标签
    batchSelectTag(type) {
      console.log(this.tagSelectionList)
      if (this.tagSelectionList.length == 0) {
        this.$message({
          message: '请选择标签',
          type: 'warning',
          // offset: 200
        });
        return
      }
      this.tagSelectionList.forEach(item => {
        if (type == 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }

      })
      let arr = this.tagList.filter(item => item.selected).map(i => {
        if (i.selected) {
          return {
            id: i.id,
            name: i.name
          }
        }
      })
      if (type == 2) {
        this.seletedTag = this.seletedTag.filter(item => !this.tagSelectionList.some(item2 => item2.id == item.id))
      } else {
        this.seletedTag = this.arrDistinctByProp(this.seletedTag.concat(arr), 'id');
      }
      this.tagSelectionList = [];
      this.$refs['tagTable'].clearSelection()
      this.$forceUpdate()
    },
    //标签多选
    handleSelectionChange(val) {
      this.tagSelectionList = val;
    },
    //商品多选
    handleGoodsSelectionChange(val) {
      this.goodsSelectionList = val;
    },
    handleGoodsSelectionChange1(val) {
      this.goodsSelectionList1 = val;
    },
    handleGoodsSelectionChange3(val) {
      this.goodsSelectionList3 = val;
    },
    //获取标签数据
    getTagList() {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize,
        status: 1,
        name: this.tagName
      }
      console.log(this.labelPageNo)
      data = Object.assign(data, this.search)
      this.axios.post('/tagPool/show/pageList', data)
        .then(res => {
          console.log(res);
          res.data.list.forEach(item => {
            item.selected = false
          })
          this.seletedTag.forEach(item => {
            res.data.list.forEach(el => {
              if (item.id == el.id) {
                el.selected = true;
              }
            })
          })
          console.log(this.seletedTag)
          console.log(res.data.list)
          this.tagList = res.data.list;
          this.labelTotalNum = res.data.totalNum;
        })
        .catch(err => {
          console.log(err);
        })
    },
    checkGoodsList() {
      this.goodsPageNo = 1;
      console.log(this.showSelectedGoods)
      if (this.showSelectedGoods) {
        this.getGoodsList()

      } else {
        this.getSelectGoodsData()
      }

    },
    handleShowSelect() {
      console.log(this.seletedGoods, this.seletedGoods1, this.seletedGoods3)

      let s = []
      s = this.seletedGoods.concat(this.seletedGoods1).concat(this.seletedGoods3)
      if (this.showSelectedGoods) {
        // if (s.length == 0) {
        //   this.$message('没有已选的商品')
        //   return
        // }
        this.gType = '3'
        this.showSelectedGoods = false;
        this.ids = s
        this.goodsPageNo = 1;
        this.getSelectGoodsData()

      } else {
        this.ids = [];
        this.gType = '1'
        this.showSelectedGoods = true;
        this.getGoodsList()
      }


    },
    getSelectGoodsData() {
      let data = {
        pageNo: this.goodsPageNo3,
        pageSize: this.goodsPageSize3,
        name: this.goodsName,
        ids: this.ids,
      }
      this.axios.post('/coupon/selectGoodsAndGiftPage', data).then(res => {
        if (res.code === 0) {
          res.data.list.forEach(item => {
            item.selected = false
          })
          this.goodsList3 = res.data.list;
          this.goodsList3.forEach(el => {
            el.selected = true;
          })
          this.goodsTotalNum3 = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
      })
    },
    //获取商品数据
    getGoodsList() {
      if (this.gType == 1) {
        let data = {
          pageNo: this.goodsPageNo,
          pageSize: this.goodsPageSize,
          nameOrGoodsNo: this.goodsName,
        }
        this.axios.post('/goods/pageList', data).then(res => {
          if (res.code === 0) {
            res.data.list.forEach(item => {
              item.selected = false
            })
            this.goodsList = res.data.list;
            // let arr = this.seletedGoods.concat(this.seletedGoods3)
            // console.log(arr, this.goodsList3, this.seletedGoods, this.seletedGoods3)
            this.goodsList3.forEach(item => {
              this.goodsList.forEach(el => {
                if (item.id == el.id) {
                  el.selected = true;
                }
              })
            })


            this.goodsTotalNum = res.data.totalNum
          } else {
            console.log('goodsPageList - 失败', type)
          }
        })
      } else {
        let data = {
          pageNo: this.goodsPageNo1,
          pageSize: this.goodsPageSize1,
          nameOrGoodsNo: this.goodsName,
        }
        this.axios.post('/giftPackage/pageList', data).then(res => {
          if (res.code === 0) {
            res.data.list.forEach(item => {
              item.selected = false
            })
            this.goodsList1 = res.data.list;
            this.goodsList3.forEach(item => {
              this.goodsList1.forEach(el => {
                if (item.id == el.id) {
                  el.selected = true;
                }
              })
            })

            // this.seletedGoods1.forEach(item => {
            //   this.goodsList1.forEach(el => {
            //     if (item.id == el.id) {
            //       el.selected = true;
            //     }
            //   })
            // })
            this.goodsTotalNum1 = res.data.totalNum
          } else {
            console.log('goodsPageList - 失败', type)
          }
        })
      }

    },
    deleteSelectedCName(idx) {
      this.selectedCName.splice(idx, 1)
      this.selectedCategory.splice(idx, 1)
      // this.getCategoryChange(this.selectedCategory)
      this.cKey++
      console.log(this.selectedCategory)
      this.$forceUpdate()
    },
    //选择类目
    getCategoryChange(e) {
      console.log(e)
      console.log(this.selectedCategory)
      console.log(this.$refs['cat'].getCheckedNodes()) //selectedCName
      this.selectedCName = this.$refs['cat'].getCheckedNodes().map(item => {
        let label = '';
        for (let i = 0; i < item.pathLabels.length; i++) {
          let j = i < (item.pathLabels.length - 1) ? '>' : ''
          label += item.pathLabels[i] + j
        }
        return label
      })
    },
    getLimitChange(e) {
      if (e == '2') {

      }
    },
    // 获取类目列表
    getCategoryList() {
      const data = { pageNo: 1, pageSize: 10000 }
      this.axios.post('/category/pageList', data).then((res) => {
        let list = res.data.list;
        // list.forEach(item=>{
        //     item.id = Number(item.id);
        //     if(item.children && item.children.length > 0){
        //         item.children.forEach(el=>{
        //             el.id = Number(el.id)
        //             if(el.children && el.children.length > 0){
        //                 el.children.forEach(i=>{
        //                     i.id = Number(i.id)
        //                 })
        //             }
        //         })
        //     }
        // })
        this.categoryList = list
        console.log(this.categoryList)
      }).catch((err) => {
        console.log(err)
      })
    },
    //数组去重
    arrDistinctByProp(arr, prop) {
      if (prop) {
        return arr.filter(function (item, index, self) {
          return self.findIndex(el => el[prop] == item[prop]) === index
        })
      } else {
        return Array.from(new Set(arr));
      }

    }
  }
}

</script>
<style  lang="scss">
.cascabox {
  .el-cascader-panel .el-scrollbar:first-child .el-checkbox {
    display: block !important;
  }
}
</style>
<style scoped lang="scss">
::v-deep .el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

::v-deep .el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

::v-deep .el-form-item__content {
  margin-bottom: 10px;
}

.bottom-but {
  margin-top: 20px;
  margin-bottom: 40px;
  // text-align: center;
  margin-left: 40px;

  .el-button {
    width: 220px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button+.el-button {
    margin-left: 32px;
  }
}

.cascabox {
  width: 70%;
  margin-top: 10px;
  position: relative;
}

.cascabtnbox {
  position: absolute;
  right: 50px;
  bottom: 10px;
  z-index: 33;
}

::v-deep .el-cascader-menu:nth-child(3) {
  flex: 1;
}

::v-deep .el-cascader-menu:nth-child(3) .el-cascader-menu__list {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
  color: #2d46ee;
  font-weight: 700;
}

.selected {
  // width: 80%;
  padding: 14px 18px;
  box-sizing: border-box;
  border: 1px dashed #E0E0E0;
  display: flex;
  align-items: center;
}

.selectedbox {
  display: flex;
  // width: 90%;
  flex-wrap: wrap;
  color: #4168E7;
  font-size: 14px;
}

.selected-item {
  margin-left: 16px;
  margin-bottom: 10px;
  background-color: #F0F3FD;
  position: relative;
  padding: 3px 14px;
  position: relative;
  border-radius: 4px;
  line-height: 28px;
}

.labeliconbox {
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
  cursor: pointer;
  background-color: white;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
}

.labelicon {
  color: #4168E7;
  font-size: 16px;
}

.table-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-top-left {
  display: flex;
  align-items: center;
}

.goods-table {
  width: 100%;
}

::v-deep .el-image {
  width: 72px;
  height: 56px;
}

.tag-status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.table-incl {
  width: 65%;
  padding: 24px;
  box-sizing: border-box;
  background-color: #E3EDFF;
}

.primary-button {
  width: 120px;
  height: 36px;
  background: #4168E7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-mini {
  width: 68px;
  height: 32px;
  background: #E3EDFF;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168E7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}

.primary-plain {
  width: 120px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #4168E7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168E7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-gray {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}
</style>